import { Trans } from '@lingui/react/macro';
import { Box, Loader, Typography } from '@pocketlaw/tetris';
export function EvaluatingState() {
    return (<Box flexDirection="column" alignItems="center" gap="xl" mt="2xl">
      <Loader size="lg"/>

      <Box flexDirection="column" alignItems="center" gap="xs">
        <Typography $fontSize="large" $fontWeight="semibold" $appearance="300">
          <Trans comment="Document approval check - Checking document title">Checking document</Trans>
        </Typography>
        <Typography $fontSize="small" $appearance="200">
          <Trans comment="Document approval check - Checking document description">
            Checking approval requirements against rules
          </Trans>
        </Typography>
      </Box>
    </Box>);
}
